import { forwardRef } from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '@/utils';

const inputVariants = cva(
	'flex w-full rounded border border-gray-200 bg-background py-2 text-sm transition-colors placeholder:text-gray-500 focus:border-black focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500',
	{
		variants: {
			size: {
				default: 'h-10 px-3',
				xl: 'h-12 px-3 text-sm lg:h-14 lg:px-4 lg:text-base',
				lg: 'h-10 px-3 py-2.5 text-sm lg:h-12 lg:text-base',
				sm: 'h-7 px-3 py-1 text-xs'
			},
			error: {
				true: 'border-border-red focus:border-border-red'
			}
		},
		defaultVariants: {
			size: 'default'
		}
	}
);

const Input = forwardRef(
	({ className, type, size, error, errorMessage, ...props }, ref) => {
		return (
			<input
				className={cn(
					inputVariants({
						size,
						className,
						error
					})
				)}
				type={type}
				ref={ref}
				{...props}
			/>
		);
	}
);

Input.displayName = 'Input';

export default Input;
